<template>
  <div style="display: none"></div>
</template>
<script>
export default {
  name: 'EcSocket',
  data () {
    return {
      lockReconnect : false,//避免重复连接
      wsUrl : process.env.NODE_ENV === "development"
              ? `ws://${process.env.IP}/pushWebsocket/${this.$store.state.orgCode}`
              : `${location.protocol === "https" ? "wss" : "ws"}://${location.host}/pushWebsocket/${this.$store.state.orgCode}`,
      ws:'',
      timeout: 30000,
      timeoutObj: null,
      serverTimeoutObj: null
    }
  },
  methods: {
    createWebSocket(){
      try {
          this.ws = new WebSocket(this.wsUrl);
          this.websocketInit();
      } catch (e) {
        console.log('catch');
        this.websocketReconnect(this.wsUrl);
      }
    },
    websocketInit () {
      let _this = this;
      // 建立 web socket 连接成功触发事件
      this.ws.onopen = function (evt) {
        _this.onOpen(evt);
      };
      // 断开 web socket 连接成功触发事件
      this.ws.onclose = function (evt) {
        // console.log('断开')
        _this.websocketReconnect(this.wsUrl);
        _this.onClose(evt);
      };
      // 接收服务端数据时触发事件
      this.ws.onmessage = function (evt) {
        _this.onMessage(evt);
      };
      // 通信发生错误时触发
      this.ws.onerror = function (evt) {
        _this.websocketReconnect(this.wsUrl);
        _this.onError(evt);
      };
    },
    onOpen(evt) {
      // console.log("建立链接");
      var sendData = { test: 'test' };        // 正常的请求数据
      sendData = JSON.stringify(sendData);
      this.ws.send(sendData);
      //心跳检测重置
      this.heartCheck();
    },
    onClose(evt) {
      // console.log("连接已关闭...");
    },
    onMessage(evt) {
      if(evt.data=='heartOk'){
        // console.log('连接正常');
      }else{
        var data = JSON.parse(evt.data);
        this.$emit('handleSocket', data)
        // this.echartData = data
        // this.render()
      }
      //拿到任何消息都说明当前连接是正常的
      this.heartCheck();
    },
    websocketReconnect(url) {
      let _this = this;
      if (this.lockReconnect) {       // 是否已经执行重连
        return;
      };
      this.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt);
      var tt = setTimeout(function () {
        _this.createWebSocket(url);
        _this.lockReconnect = false;
      }, 5000);
    },
    heartCheck(){
        var _this = this;
        _this.timeoutObj && clearTimeout(_this.timeoutObj);
        _this.serverTimeoutObj && clearTimeout(_this.serverTimeoutObj);
        _this.timeoutObj = setTimeout(function () {
        //发送测试信息，后端收到后，返回一个消息，
        _this.ws.send("heart")
        _this.serverTimeoutObj = setTimeout(function () {
          _this.ws.close();
        }, _this.timeout);
      }, _this.timeout)
    },
    onError(evt) {
      console.log('通信错误：' + evt.data);
    },
    beforeunloadHandler (e) {
      this.ws.close();
    }
  },
  mounted () {
    this.createWebSocket()
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  //离开当前页面后执行
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcSocket.vue